import "@/App.css";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import EmployeeApp from "@/pages/EmployeeApp";
import AdminApp from "@/pages/AdminApp";

function Root() {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Login />;
  return user.role === "admin" ? <AdminApp /> : <EmployeeApp />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Root />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}
